<div class="content-wrapper">
  <h1>404</h1>
  <div>
    <h4>Page not found</h4>
    <h5 style="font-size: 12px">
      Sorry the page you were looking for could not be found.
    </h5>
    <button type="submit" routerLink="/home" class="btn-go-home">
      Go to home
    </button>
  </div>
</div>
